import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X } from "lucide-react";

const LOGO_URL = "/logo-olive.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => setOpen(false), [location.pathname]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/tools", label: "Tools" },
    { to: "/about", label: "About" },
    { to: "/blog", label: "Blog" },
    { to: "/booking", label: "Book" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="site-header sticky top-0 z-40 backdrop-blur-md bg-[rgba(245,244,239,0.93)] border-b border-[#23261C]/10">
      <div className="container-if flex items-center justify-between py-3">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img
            src={LOGO_URL}
            alt="Infantry Financial"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" className="nav-link active" data-testid="nav-dashboard">
                Dashboard
              </Link>
              <Link to="/profile" className="nav-link" data-testid="nav-profile">
                Profile
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" className="nav-link active" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <button onClick={logout} className="btn-outline !py-2 !px-4 !text-[12px]" data-testid="nav-logout-btn">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link" data-testid="nav-login-link">
                Sign in
              </Link>
              <Link to="/booking" className="btn-gold !py-2.5 !px-5 !text-[12px]" data-testid="nav-book-btn">
                Free Consultation
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden text-[#23261C]"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#23261C]/10 bg-[var(--if-bg)]">
          <div className="container-if py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            {user ? (
              <>
                <Link to="/dashboard" className="nav-link active">Dashboard</Link>
                <Link to="/profile" className="nav-link">Profile</Link>
                {user.role === "admin" && <Link to="/admin" className="nav-link active">Admin</Link>}
                <button onClick={logout} className="btn-outline self-start !py-2 !px-4 !text-[12px]">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="nav-link">Sign in</Link>
                <Link to="/booking" className="btn-gold self-start !py-2 !px-4 !text-[12px]">Free Consultation</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
